import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: auto;
  flex-wrap: wrap;
  gap: 5px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Option = styled.div`
  border-color: #e5e5e5;
  transition: all 0.3s ease;
  border: 1px solid #146ec3;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 10px;
  white-space: nowrap;
  flex: 1;
  max-width: 48%;

  cursor: pointer;

  &:hover {
    color: gold;
  }

  &.selected {
    background-color: #146ec3;
    color: white;
  }
`;

export const Text = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
`;
